module.exports = __webpack_public_path__ + "9de160d08c10fbaf5bb88ce489a0a9b0.png";